export default __webpack_public_path__ + "static/media/eye-slash-solid.0bed875c.svg";